import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function Privacy() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <nav className="container">
          <Link to="/" className="back-link">← 返回首页</Link>
        </nav>
      </header>
      <div className="container">
        <h1>隐私政策</h1>
        <p className="last-updated">最后更新：2024年11月</p>

        <section className="legal-section">
          <h2>引言</h2>
          <p>杭州斯代拉科技有限公司（以下简称"我们"）非常重视用户的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。</p>
          <p>使用我们的服务即表示您同意本隐私政策。如果您不同意本政策的任何内容，请不要使用我们的服务。</p>
        </section>

        <section className="legal-section">
          <h2>1. 信息收集</h2>

          <h3>1.1 我们可能收集的信息</h3>
          <ul>
            <li><strong>基本信息：</strong>姓名、联系电话、电子邮箱</li>
            <li><strong>公司信息：</strong>公司名称、职位、公司地址</li>
            <li><strong>项目信息：</strong>项目需求描述、预算范围、期望交付时间</li>
            <li><strong>技术信息：</strong>IP地址、浏览器类型、访问时间、访问页面</li>
            <li><strong>沟通记录：</strong>电话、邮件、QQ等沟通内容</li>
            <li><strong>其他信息：</strong>您主动提供的其他信息</li>
          </ul>

          <h3>1.2 信息收集方式</h3>
          <ul>
            <li>您通过网站表单、电话、邮件、QQ等方式主动提供</li>
            <li>您使用我们的网站时自动收集的技术信息</li>
            <li>通过Cookie等技术收集的浏览行为信息</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. 信息使用</h2>
          <p>我们收集的信息仅用于以下目的：</p>
          <ul>
            <li><strong>提供服务：</strong>处理您的咨询、提供开发服务、项目沟通与管理</li>
            <li><strong>服务改进：</strong>分析用户需求，改进服务质量和用户体验</li>
            <li><strong>沟通联系：</strong>发送服务通知、项目进度更新、技术支持信息</li>
            <li><strong>合同履行：</strong>签订合同、开具发票、处理付款</li>
            <li><strong>法律义务：</strong>遵守法律法规要求，保护合法权益</li>
            <li><strong>安全保障：</strong>防范欺诈、保护系统安全</li>
          </ul>
          <p><strong>我们承诺：</strong>不会将您的信息用于营销推广，除非获得您的明确同意。</p>
        </section>

        <section className="legal-section">
          <h2>3. 信息共享与披露</h2>

          <h3>3.1 我们不会出售、出租或交易您的个人信息</h3>

          <h3>3.2 以下情况下我们可能共享或披露您的信息：</h3>
          <ul>
            <li><strong>获得您的明确同意</strong></li>
            <li><strong>法律要求：</strong>根据法律法规、法律程序、诉讼或政府要求</li>
            <li><strong>保护权益：</strong>为保护本公司、用户或公众的合法权益</li>
            <li><strong>紧急情况：</strong>在紧急情况下保护用户或公众的人身安全</li>
            <li><strong>服务提供商：</strong>与为我们提供服务的第三方（如云服务商、支付服务商）共享必要信息，但要求其严格保密</li>
            <li><strong>业务转让：</strong>如发生合并、收购或资产转让，您的信息可能被转移，我们会提前通知您</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. 信息存储与保护</h2>

          <h3>4.1 存储地点</h3>
          <p>您的信息存储在中国境内的服务器上。</p>

          <h3>4.2 存储期限</h3>
          <ul>
            <li>咨询信息：保留1年</li>
            <li>合同信息：保留至合同履行完毕后3年</li>
            <li>项目文档：保留至项目交付后3年</li>
            <li>财务信息：按照税务法规要求保留</li>
          </ul>

          <h3>4.3 安全措施</h3>
          <p>我们采取以下措施保护您的信息安全：</p>
          <ul>
            <li>使用加密技术（HTTPS/SSL）传输敏感信息</li>
            <li>采用防火墙、入侵检测等技术防范网络攻击</li>
            <li>严格限制访问权限，仅授权人员可访问个人信息</li>
            <li>对员工进行数据安全培训，签署保密协议</li>
            <li>定期审查和更新安全措施</li>
            <li>制定数据泄露应急预案</li>
          </ul>

          <h3>4.4 安全事件处理</h3>
          <p>如发生个人信息泄露等安全事件，我们将：</p>
          <ul>
            <li>立即启动应急预案，采取补救措施</li>
            <li>及时通知受影响的用户</li>
            <li>向相关监管部门报告</li>
            <li>配合调查并承担相应责任</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. 您的权利</h2>
          <p>您对自己的个人信息享有以下权利：</p>

          <h3>5.1 访问权</h3>
          <p>您有权查询我们持有的您的个人信息。</p>

          <h3>5.2 更正权</h3>
          <p>如发现信息不准确或不完整，您有权要求更正。</p>

          <h3>5.3 删除权</h3>
          <p>在以下情况下，您有权要求删除您的个人信息：</p>
          <ul>
            <li>我们违反法律法规或与您的约定收集、使用信息</li>
            <li>我们违反法律法规或与您的约定共享、转让信息</li>
            <li>您撤回同意</li>
            <li>您注销账户</li>
            <li>我们终止服务</li>
          </ul>

          <h3>5.4 撤回同意权</h3>
          <p>您有权撤回对信息使用的授权同意。撤回同意不影响撤回前的信息处理。</p>

          <h3>5.5 注销权</h3>
          <p>您有权注销账户。注销后我们将停止提供服务，并删除您的个人信息，法律法规另有规定的除外。</p>

          <h3>5.6 获取副本权</h3>
          <p>您有权获取您的个人信息副本。</p>

          <h3>5.7 行使权利的方式</h3>
          <p>如需行使上述权利，请通过以下方式联系我们：</p>
          <ul>
            <li>电话：15000416741</li>
            <li>邮箱：454784911@qq.com</li>
            <li>QQ：454784911</li>
          </ul>
          <p>我们将在15个工作日内回复您的请求。</p>
        </section>

        <section className="legal-section">
          <h2>6. Cookie和类似技术</h2>

          <h3>6.1 什么是Cookie</h3>
          <p>Cookie是网站存储在您设备上的小型文本文件，用于识别您的浏览器。</p>

          <h3>6.2 我们如何使用Cookie</h3>
          <ul>
            <li>记住您的偏好设置</li>
            <li>分析网站流量和用户行为</li>
            <li>改善用户体验</li>
            <li>提供个性化内容</li>
          </ul>

          <h3>6.3 如何管理Cookie</h3>
          <p>您可以通过浏览器设置管理或删除Cookie。但这可能影响网站的某些功能。</p>
        </section>

        <section className="legal-section">
          <h2>7. 第三方服务</h2>
          <p>我们的网站可能包含第三方链接或服务（如支付平台、地图服务等）。这些第三方有自己的隐私政策，我们不对其隐私做法负责。建议您查看其隐私政策。</p>
        </section>

        <section className="legal-section">
          <h2>8. 未成年人保护</h2>
          <p>我们的服务面向企业客户，不针对未成年人。如果您是未成年人，请在监护人同意和指导下使用我们的服务。</p>
          <p>如果我们发现在未获得监护人同意的情况下收集了未成年人的信息，将尽快删除。</p>
        </section>

        <section className="legal-section">
          <h2>9. 隐私政策的更新</h2>
          <p>我们可能不时更新本隐私政策。更新后的政策将在网站上公布，并注明更新日期。</p>
          <p>如有重大变更，我们会通过网站公告、邮件等方式通知您。</p>
          <p>继续使用我们的服务即表示您接受更新后的隐私政策。</p>
        </section>

        <section className="legal-section">
          <h2>10. 适用法律与管辖</h2>
          <p>本隐私政策的解释、执行和争议解决适用中华人民共和国法律。</p>
          <p>如发生争议，双方应友好协商解决；协商不成的，提交杭州市余杭区人民法院诉讼解决。</p>
        </section>

        <section className="legal-section">
          <h2>11. 联系我们</h2>
          <p>如果您对本隐私政策有任何疑问、意见或建议，或需要行使您的权利，请通过以下方式联系我们：</p>
          <ul>
            <li><strong>公司名称：</strong>杭州斯代拉科技有限公司</li>
            <li><strong>联系电话：</strong>15000416741</li>
            <li><strong>客服QQ：</strong>454784911</li>
            <li><strong>电子邮箱：</strong>454784911@qq.com</li>
            <li><strong>工作时间：</strong>周一至周五 9:00-18:00</li>
            <li><strong>公司地址：</strong>浙江省杭州市余杭区高教镇凤仪大道966号2号楼6层603室6414室</li>
          </ul>
          <p>我们将在15个工作日内回复您的请求。</p>
        </section>

        <section className="legal-section">
          <p className="legal-note">感谢您信任杭州斯代拉科技有限公司。我们将持续努力保护您的隐私和数据安全。</p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
